<template>
  <div class="main-wrapper">
    <div class="main-header">
      <EBreadcrumb />
      <slot name="header-btn"></slot>
    </div>
    <slot
      v-if="$slots.customCon"
      name="customCon"
    ></slot>
    <div
      v-else
      class="main-content"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
import EBreadcrumb from './EBreadcrumb.vue';
export default {
  components: {
    EBreadcrumb
  }
};
</script>
<style lang="less" scoped>
.main-wrapper {
  padding: 16px;
  box-sizing: border-box;
  .main-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    .el-button--default {
      border: 1px solid @primary-color!important;
      color: @primary-color!important;
      background: none !important;
    }
  }
  .main-content {
    border-radius: 12px;
    background: #fff;
    padding: 16px;
  }
}
</style>
